import { TableCell, TableRow, Tooltip } from '@material-ui/core'
import BlockIcon from '@material-ui/icons/Block'
import EditIcon from '@material-ui/icons/Edit'
import FileCopy from '@material-ui/icons/FileCopy'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { PROTECTED_EMPLOYEE_EMAILS } from '@/domains/employees/constants'
import { Employee } from '@/schemaTypes'
import globalStyles from '@/styles/global.module.scss'

dayjs.extend(utc)

export interface EmployeesRowProps {
  employee: Employee
  deactivateEmployee: () => void
}

const EmployeesRow = (props: EmployeesRowProps) => {
  const { employee } = props
  const { t } = useTranslation()
  const id = employee._id ?? ''

  return (
    <TableRow>
      <TableCell component="th" scope="row">
        {id}
      </TableCell>
      <TableCell align="right">{employee.email}</TableCell>
      <TableCell align="right">{employee.firstname}</TableCell>
      <TableCell align="right">{employee.lastname}</TableCell>
      <TableCell align="right">
        {employee.dateOfBirth
          ? dayjs(employee.dateOfBirth).format('DD.MM.YYYY')
          : ''}
      </TableCell>
      <TableCell align="right">{employee.phone}</TableCell>
      <TableCell align="right">{employee.sex}</TableCell>
      <TableCell align="right">{employee.roles.join(' ')}</TableCell>
      <TableCell>
        <Link to={`/inApp/configurations/employees/create/${id}`}>
          <FileCopy />
        </Link>
        <Link to={`/inApp/configurations/employees/edit/${id}`}>
          <EditIcon />
        </Link>
        {!PROTECTED_EMPLOYEE_EMAILS.includes(employee.email) && (
          <Tooltip title={t('deactivate')}>
            <BlockIcon
              color="action"
              className={globalStyles.clickable}
              onClick={props.deactivateEmployee}
            />
          </Tooltip>
        )}
      </TableCell>
    </TableRow>
  )
}

export default EmployeesRow
